import React, { forwardRef } from 'react';

/**
 * ## ⛸️ Wrapn ([repo](https://github.com/wrapn/wrapn))
 * Wrap any HTML Element into a styled component!
 *
 * - ⏱️ Create the fastest components using Tailwind.
 * - 🎾 Autocomplete provides a joyful experience.
 * - 🌯 Only an HTML element, but a styled one.
 *
 *
 * ### Wrap an HTML tag
 * ```jsx
 * // <MyButton/>
 * const MyButton = wrapn('button')`
 *     h-12 px-6
 *     text-white
 *     bg-blue-500
 * `
 * ```
 *
 *
 * ### Wrap a component
 * ```jsx
 * // Create a base component
 * const ButtonBase = wrapn('button')`
 *     h-12 px-6
 * `
 * // <ButtonPrimary/>
 * const ButtonPrimary = wrapn(ButtonBase)`
 *     bg-blue-500
 * `
 * // <ButtonSecondary/>
 * const ButtonSecondary = wrapn(ButtonBase)`
 *     bg-gray-500
 * `
 * ```
 *
 *
 * ### TailwindCSS Intellisense
 * - Install Tailwind CSS IntelliSense Extension to VS Code.
 * - Press Ctrl + Shift + P keys at the same time.
 * - Type Open User Settings (JSON) in the search box.
 * - Put the content below inside the settings object.
 *
 * `------------------------------------------------`
 * ```json
 * "editor.quickSuggestions": {
 *      "strings": true
 * },
 * "tailwindCSS.experimental.classRegex": [
 *      "wrapn\\(.*?\\)`([^`]*)"
 * ],
 * ```
 * `------------------------------------------------`
 *
 * - Done! You can now use Tailwind CSS IntelliSense.
 *
 * ### Made with ❤️ by Wrapn contributors...
 */
const wrapn = (Tag) => {
    return (tw) => {
        return forwardRef((props, ref) => React.createElement(Tag, { ...{ ...props, className: `${tw} ${props.className || ''}`, ref } }));
    };
};

export { wrapn };
